import './PopupMenu.scss';

import { MoreOutlined } from '@ant-design/icons';
import { Button, Popover, Tooltip } from 'antd';
import { cloneElement, ReactElement, ReactNode, useMemo } from 'react';

interface PopupMenuProps {
  className?: string;
  openButton?: ReactElement;
  disabled?: boolean;
  tooltip?: string;
  menuContent: ReactNode;
}

const PopupMenu = (props: PopupMenuProps) => {
  const openButton = useMemo(
    () =>
      props.openButton ? (
        cloneElement(props.openButton, { disabled: props.disabled })
      ) : (
        <Button disabled={props.disabled} icon={<MoreOutlined />}></Button>
      ),
    [props.disabled, props.openButton],
  );

  return (
    <Popover
      rootClassName={`PopupMenu ${props.className}`}
      placement="bottomRight"
      trigger="click"
      content={<div className="PopupMenuItems">{props.menuContent}</div>}>
      <Tooltip title={props.tooltip}>{openButton}</Tooltip>
    </Popover>
  );
};

export default PopupMenu;
